import { render, staticRenderFns } from "./OtherUserReceiveMessageList.vue?vue&type=template&id=722510a0&lang=pug"
import script from "./OtherUserReceiveMessageList.vue?vue&type=script&lang=ts"
export * from "./OtherUserReceiveMessageList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports